import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_theme_instance_ext_RowClass, bl_cms_theme_instance_hdr_RowClass} from '../../../dbschema';

export class ThemeInstanceContainerModel extends BaseContainerModel {

  bl_cms_theme_instance_hdr: bl_cms_theme_instance_hdr_RowClass = new bl_cms_theme_instance_hdr_RowClass();
  bl_cms_theme_instance_exts: bl_cms_theme_instance_ext_RowClass[] = [];
}
